import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/caret-square-left': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M272 157.1V354.9C272 365.6 259 371 251.5 363.4L153.2 264.5C148.5 259.8 148.5 252.3 153.2 247.6L251.5 148.7C259 141 272 146.4 272 157.1zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM400 426V86C400 82.7 397.3 80 394 80H54C50.7 80 48 82.7 48 86V426C48 429.3 50.7 432 54 432H394C397.3 432 400 429.3 400 426z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/caret-square-left.js
// module id = F3+I
// module chunks = 144